<template>
  <div>
  <section id="sub_visual" class="pic10">
    <p>이트너스 컨시어지 소개</p>
    <span>About etners Concierge Service</span> </section>
  <main id="page_sub">
    <section id="page_contents" class="sub_con10 clear">
      <h6>최상의 의료 서비스<br/>
        연결을 위한 모든 것</h6>
      <span class="ctext1">이트너스 컨시어지는 이트너스 쉐어드서비스를 병/의원에 도입하여 <br/>
      외국인 환자 대상 맞춤 의료서비스를 추천하고 의료연게 부가서비스 일체를 제공합니다.</span>
      <p class="ctext2 ml0 pt100"><span class="cbig">Why</span><span class="pl0">etners Concierge?</span></p>
      <!--- 특징 --->
      <div class="clearfix">
        <ul class="platform">
          <li class="thr">
            <p><img src="../../assets/images/c_im_24.png" width="104" height="104" alt=""/></p>
            <h6>의료 컨시어지의 A부터 Z까지 </h6>
            <p>오랜시간 고객 가치향상에 기여한 경험을 바탕으로
              글로벌 헬스케어 시장 외국인환자 대상 맞춤 의료서비스를 추천하고 컨시어지 솔루션을 제공합니다. </p>
          <li class="thr">
            <p><img src="../../assets/images/c_im_22.png" width="104" height="104" alt=""/></p>
            <h6>자체 배차관리 시스템 으로 편의서비스 증대 </h6>
            <p>전문화된 솔루션을 바탕으로 공항픽업 및 병원도착안내를 통해 보다 편리한 의료 연결 서비스를 제공합니다. </p>
          </li>
          <li class="thr">
            <p><img src="../../assets/images/c_im_16.png" width="104" height="104" alt=""/></p>
            <h6>병/의원 커넥팅 비지니스 </h6>
            <p>다년간의 쉐어드서비스 복리후생과 총무 업무 경험을 바탕으로 환자의 질병/상황에 적합한 정보 제공 및 의료 커넥팅 비지니스를 제공합니다. </p>
          </li>
        </ul>
        <!--- 컨시어지서비스 --->
        <h4>About Concierge Service </h4>
        <ul class="platform">
          <li class="fiv">
            <p><img src="../../assets/images/se_07.png" alt="" /></p>
            <h6>통역 </h6>
          </li>
          <li class="fiv">
            <p><img src="../../assets/images/se_08.png" alt=""/></p>
            <h6>비자관리 </h6>
          </li>
          <li class="fiv">
            <p><img src="../../assets/images/se_09.png" alt=""/></p>
            <h6>항공/숙박예약 </h6>
          </li>
          <li class="fiv">
            <p><img src="../../assets/images/se_10.png" alt=""/></p>
            <h6>Relocation </h6>
          </li>
          <li class="fiv">
            <p><img src="../../assets/images/se_11.png" alt=""/></p>
            <h6>투어프로그램 </h6>
          </li>
        </ul>
        <!--- //컨시어지서비스 --->
        <ul class="platform">
          <li><img src="../../assets/images/se_bot.png" alt="" /></li>
        </ul>
      </div>
      <!--- //특징 --->
      <div class="btn_area2">
        <button class="k-primary k-button k-big" data-role="button" role="button" aria-disabled="false" tabindex="0" @click="goConcierge">컨시어지 웹 관리자 바로가기</button>
      </div>
    </section>
  </main>
  </div>
</template>

<script>
  import JwtService from "@/common/jwt.service";
  export default {
    name : "etnersconcierge",
    data() {
      return{

      }
    },
    methods:{
      goConcierge:function () {
        if(sessionStorage.getItem('conciergeDomain') == null){
          this.$store.fetch('FETCH_URL')
        }
        let url  = sessionStorage.getItem('conciergeDomain')

              let lutk = JwtService.getToken()

              window.open(url+'?loginUserToken='+lutk)


      }
    }
  }

</script>
